<div
  class="h-12 px-5 text-white w-full flex items-center justify-center"
>
  <div class="flex items-center space-x-3">
    <img *ngIf="footerLogo" [src]="footerLogo" alt="" class="h-10" />
    <span class="text-sm hidden md:block">© 2025. All rights reserved. SigmaT Consultancy Pvt. Ltd.
    </span>
  </div>
</div>
